import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'components';
import './style.scss';

function CalendarRangeNavigator({
  text = '',
  onForwardClick = () => {},
  onBackwardClick = () => {},
}) {
  return (
    <div className="tv-calendar_range_navigator">
      <IconButton
        iconName="chevron-left"
        onClick={onBackwardClick}
        className="tv-calendar_range_navigator__icon"
      />
      <span>{text}</span>
      <IconButton
        iconName="chevron-right"
        onClick={onForwardClick}
        className="tv-calendar_range_navigator__icon"
      />
    </div>
  );
}

CalendarRangeNavigator.propTypes = {
  text: PropTypes.string,
  onForwardClick: PropTypes.func,
  onBackwardClick: PropTypes.func,
};

export default CalendarRangeNavigator;
